import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class StorageService {
  private apiUrl = environment.backendUrl + '/storage';

  constructor(private http: HttpClient) {}

  getSasUrl(blobPath: string): Observable<{ url: string }> {
    console.log('[StorageService] Solicitando SAS de subida:', blobPath);
    return this.http.get<{ url: string }>(`${this.apiUrl}/sas`, {
      params: { blobPath }
    });
  }

  getReadUrl(blobPath: string): Observable<{ url: string }> {
    console.log('[StorageService] Solicitando SAS de lectura:', blobPath);
    return this.http.get<{ url: string }>(`${this.apiUrl}/sas-read`, {
      params: { blobPath }
    });
  }

  uploadFileToBlob(sasUrl: string, file: File): Promise<Response> {
    console.log('[StorageService] Subiendo archivo a Azure Blob:', sasUrl);
    return fetch(sasUrl, {
      method: 'PUT',
      headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': file.type,
      },
      body: file
    });
  }

  getSignedUrl(blobPath: string): Observable<string> {
    return this.getReadUrl(blobPath).pipe(
      map(response => response.url)
    );
  }

  /**
   * 👇 Dummy temporal para que compile auth.effects.ts
   */
  signUrl(url: string): string {
    return url;
  }
}
